import { createApp } from 'vue';
import App from './App.vue';

import './registerServiceWorker';
import './assets/scss/global.scss';

const app = createApp(App);
app.mount('#app'); 
